<!-- ============================================================
     TEMPLATE 1 (OTT) — video cards
     Reference: LA48AF_1_updated.HTM `#vmGrid` / `.vm-card`. Chrome only:
     same rows, same `pass_data` click-out. The list layout is this same DOM
     restyled from an ancestor attribute (`[data-vm-view='list']`), the
     pattern `template1-event-card` already uses for the Events grid/list.
     ============================================================ -->
<div id="st_video_common_cards_t1_grid" class="t1-vm-grid" *ngIf="isTemplate1">
  @for (item of videos_list; track cardKey(item)) {
  <button type="button" class="t1-vm-card" (click)="pass_data(item)">
    <span class="t1-vm-thumb">
      <img [src]="t1Thumbnail(item)" alt="" />
      @if (item.part) {
      <span class="t1-vm-chip t1-vm-chip--part">{{ 'video_part' | translate: { number: item.part.number } }}</span>
      }
      @if (isLiveCard(item)) {
      <span class="t1-vm-chip t1-vm-chip--live"><span class="t1-vm-chip-dot"></span>{{ 'live' | translate }}</span>
      } @else if (item.stream_status === 'TBS' && item.match_details?.start_time) {
      <span class="t1-vm-chip t1-vm-chip--time">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <polyline points="12 7 12 12 15.5 14" />
        </svg>
        {{ item.match_details?.start_time | date: 'dd MMM' }}, {{ formatScheduleTime(item.match_details?.start_time) }}
      </span>
      }
      @if (partDuration(item); as duration) {
      <span class="t1-vm-chip t1-vm-chip--duration">{{ duration }}</span>
      } @else if (item.views > 0) {
      <span class="t1-vm-chip t1-vm-chip--views">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        {{ item.views }}
      </span>
      }
    </span>
    <span class="t1-vm-body">
      <span class="t1-vm-title">{{ t1Title(item) }}@if (item.part) { | {{ 'video_part' | translate: { number: item.part.number } }}}</span>
      <span class="t1-vm-sub">{{ item.event_name }}</span>
      @if (t1ScheduleLine(item)) {
      <span class="t1-vm-loc">{{ t1ScheduleLine(item) }}</span>
      }
      <span class="t1-vm-tags">
        @for (tag of t1Tags(item); track $index) {
        <span class="t1-vm-tag">{{ tag | translate }}</span>
        }
      </span>
    </span>
  </button>
  }
</div>

<div id="st-video-common-cards-stvideocontainer" *ngIf="!isTemplate1" class="st_video_container"
  [class._mobile]="screenWidth < 500">
  @for (item of videos_list; track cardKey(item)) {
  <button type="button" (click)="pass_data(item)" (keydown.enter)="pass_data(item)" (keydown.space)="$event.preventDefault(); pass_data(item)" [id]="'st-video-common-cards-stvideocard' + cardKey(item)"
    class="st_video_card">
    <div [id]="'st-video-common-cards-imgcontainer' + cardKey(item)" class="img_container position-relative">
      @if (item.part) {
      <div [id]="'st-video-common-cards-part' + cardKey(item)"
        class="part-badge position-absolute d-flex align-items-center fs-11 fw-semibold px-2 py-1">
        {{ 'video_part' | translate: { number: item.part.number } }}
      </div>
      }
      @if (isLiveCard(item)) {
      <div [id]="'st-video-common-cards-live' + cardKey(item)"
        class="live position-absolute d-flex gap-1 align-items-center justify-content-center">
        <img src="../../../../assets/SvgIcons/live_white_dot.svg" alt="" width="8" height="8" />
        <p class="f_12 f_700">{{ 'live' | translate | capitalizeTitle }}</p>
      </div>
      }
      @if (item.stream_status == 'TBS' && item.match_details?.start_time) {
      <div [id]="'st-video-common-cards-stream-tbs-wrapper' + cardKey(item)"
        class="stream-tbs-wrapper position-absolute d-flex align-items-center">
        <div [id]="'st-video-common-cards-stream' + cardKey(item)"
          class="stream stream-date-time gap-1 d-flex align-items-center justify-content-center">
          <img src="../../../../assets/icons_svg/starting_soon.svg" alt="" width="12" height="12" />
          <p class="count mb-0 stream-meta-text">
            {{ item.match_details?.start_time | date:'dd-MM-yyyy' }} | {{ item.match_details?.start_time | date:'HH:mm'
            }}
          </p>
        </div>
        @if (item?.venue_table_id) {
        <div [id]="'st-video-common-cards-stream-1' + cardKey(item)"
          class="stream stream-table d-flex align-items-center justify-content-center">
          <p class="count mb-0" style="white-space: nowrap">{{ surfaceLabel }} {{ getTableNumber(item) }}</p>
        </div>
        }
      </div>
      }
      @if (item.views > 0) {
      <div [id]="'st-video-common-cards-views-container' + cardKey(item)"
        class="views-container d-flex gap-1 align-items-center">
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true">
          <path
            d="M8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z"
            fill="white" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.882274 5.63113C1.87378 2.65047 4.68528 0.5 8.00035 0.5C11.3139 0.5 14.1243 2.64848 15.117 5.62697C15.1973 5.86768 15.1973 6.12812 15.1173 6.36887C14.1257 9.34953 11.3142 11.5 7.99918 11.5C4.68565 11.5 1.87522 9.35153 0.882492 6.37303C0.802265 6.13233 0.802188 5.87188 0.882274 5.63113ZM11.5 6C11.5 7.933 9.933 9.5 8 9.5C6.067 9.5 4.5 7.933 4.5 6C4.5 4.067 6.067 2.5 8 2.5C9.933 2.5 11.5 4.067 11.5 6Z"
            fill="white" />
        </svg>
        <p class="count">{{ item.views }}</p>
      </div>
      }
      <img
        [src]="item.thumbnail || item?.match_details?.event_thumbnail || item.event_banner || item?.match_details?.event_banner"
        [alt]="item.title || item.event_name || ''" />
    </div>

    <div [id]="'st-video-common-cards-stcontentwrapper' + cardKey(item)" class="st_content_wrapper d-flex flex-column gap-1">
      @if (item.event_type != 'B') {
      @if (namedParticipantNames(item); as names) {
      @if (names.length > 1) {
      <div [id]="'st-video-common-cards-stheadingi' + cardKey(item)" class="st_heading_I">
        {{ names[0] }}
        {{ 'vs' | translate }}
        {{ names[1] }}
      </div>
      } @else if (names.length === 1) {
      <div [id]="'st-video-common-cards-stheadingi' + cardKey(item)" class="st_heading_I">
        {{ names[0] }}
      </div>
      }
      }
      }
      @if (item.event_type === 'B' || item.object_type == 'BROADCAST') {
      <div [id]="'st-video-common-cards-stheadingi-2' + cardKey(item)" class="st_heading_I">
        {{ item.title | capitalizeTitle }}@if (item.part) { | {{ 'video_part' | translate: { number: item.part.number } }}}
      </div>
      }
      <div [id]="'st-video-common-cards-stheadingi-3' + cardKey(item)" class="st_heading_II">
        {{ item.event_name | capitalizeTitle }}
      </div>
    </div>

    <div [id]="'st-video-common-cards-block' + cardKey(item)" class="d-flex gap-2 flex-wrap">
      @if (objectTypeI18nKey(item.object_type); as objectTypeKey) {
      <div [id]="'st-video-common-cards-stvideocategories' + cardKey(item)" class="st_video_categories">
        {{ objectTypeKey | translate | capitalizeTitle }}
      </div>
      } @else if (item.object_type) {
      <div [id]="'st-video-common-cards-stvideocategories' + cardKey(item)" class="st_video_categories">
        {{ item.object_type }}
      </div>
      }
      @if ((item.category && item.category !== 'string') && item.event_type != 'B') {
      <div [id]="'st-video-common-cards-stvideocategories-4' + cardKey(item)" class="st_video_categories">
        {{ item?.category }}
      </div>
      }
      @if ((item.category_description && item.category_description !== 'string') && (item.event_type === 'B' ||
      item.object_type == 'BROADCAST')) {
      <div [id]="'st-video-common-cards-stvideocategories-5' + cardKey(item)" class="st_video_categories">
        {{ item?.category_description }}
      </div>
      }
      @if (roundNotation(item); as notation) {
      <div [id]="'st-video-common-cards-stvideocategories-6' + cardKey(item)" class="st_video_categories">
        {{ notation }}
      </div>
      }
      @if (partDuration(item); as duration) {
      <span [id]="'st-video-common-cards-part-duration' + cardKey(item)" class="part-duration ms-auto fs-12 fw-medium">{{ duration }}</span>
      }
    </div>

    @if (item.stream_status != 'TBS' && ((item?.match_details?.table_ids?.length > 0) ||
    item?.match_details?.start_time)) {
    <div [id]="'st-video-common-cards-schedule-info' + cardKey(item)"
      class="schedule-info d-flex align-items-center fw-semibold">
      @if (item?.match_details?.start_time) {
      <span class="fw-semibold">{{ formatScheduleDate(item.match_details.start_time) }}</span>
      <span class="schedule-separator">|</span>
      <span class="fw-semibold">{{ formatScheduleTime(item.match_details.start_time) }}</span>
      }
      @if (item?.match_details?.start_time && (item?.match_details?.table_ids?.length > 0)) {
      <span class="schedule-separator">|</span>
      }
      @if (getTableNumber(item) != null) {
      <span class="fw-semibold">{{ surfaceLabel }} {{ getTableNumber(item) }}</span>
      }
    </div>
    }
  </button>
  }
</div>